import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import '@adornis/buildify/client/x-buildify.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/digitale-helden-shared/client/theme/buildify/d-buildify.js';
import '@adornis/digitale-helden-shared/client/theme/d-button.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs';
import { getMarketingBuildifyExtensions } from '../../buildify/client/helpers.js';
import { GlobalComponent } from '../../db/GlobalComponent.js';
import { MarketingVisualizeBuildify } from '../../features/buildify/client/MarketingVisualizeBuildify.js';

@customElement('marketing-global-component')
export class MarketingGlobalComponent extends ChemistryLitElement {
  @property({ attribute: false }) additionalExtensions: BuildifyExtension[] = [];
  @property({ attribute: false }) identifier = new RXController<string>(this, undefined);
  @state() private readonly _component = new RXController(
    this,
    this.identifier.observable.pipe(
      filter(Boolean),
      distinctUntilChanged(),
      switchMap(id => {
        return GlobalComponent.subscribeAndEnsureGlobalComponent(id)(GlobalComponent.allFields);
      }),
      takeUntil(this.disconnected),
    ),
  );

  @state() _extensions = new RXController(this, getMarketingBuildifyExtensions());

  override render() {
    const component = this._component.value;
    if (!component) return nothing;

    return html`
      ${MarketingVisualizeBuildify({
        value: component.content,
        entityData: component,
        mode: 'view',
        getExtensions: () => Promise.resolve([...(this._extensions.value ?? []), ...this.additionalExtensions]),
      })}
    `;
  }
}
